<template>
	<div>
		<div class="top_box">
			<h2>{{langtrans().dddsqz[languageIndex]}}</h2>
			<div class="time_box">
				<div class="block st_box">
					{{langtrans().qssjj[languageIndex]}}
					<el-date-picker @change="sttime()" v-model="st_time" align="right" type="date" :placeholder="langtrans().qssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block en_box">
					{{langtrans().jjss[languageIndex]}}
					<el-date-picker @change="entime()" v-model="en_time" align="right" type="date" :placeholder="langtrans().jjssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block">
					<el-button type="primary" @click="filt()">{{langtrans().czx[languageIndex]}}</el-button>
				</div>
			</div>
		</div>
		<div class="form_box">
			<el-table :empty-text="langtrans().zwmsss[languageIndex]" :data="tableData" border>
				<el-table-column :label="langtrans().xhh[languageIndex]" min-width="50">
          <template slot-scope="scope">
            {{scope.row.casenumber}}
            <span v-if="scope.row.subRegulatorId != null && scope.row.subRegulatorId != '' && scope.row.subRegulatorId != undefined">({{scope.row.subRegulatorId}})</span>
          </template>
				</el-table-column>
				<el-table-column prop="casenumber" :label="langtrans().ajbhh[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="address" :label="langtrans().ffsddd[languageIndex]" min-width="140">
				</el-table-column>
				<el-table-column prop="username" :label="langtrans().yhxm[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="phone" :label="langtrans().yhsjhh[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="papers" :label="langtrans().zjxsxx[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="sex" :label="langtrans().xbb[languageIndex]" min-width="50">
				</el-table-column>
				<el-table-column prop="time" :label="langtrans().cxsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="par" :label="langtrans().yhbxxq[languageIndex]" min-width="90">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">{{langtrans().bxxqq[languageIndex]}}</el-button>
						<el-button type="text" size="small" v-show="!scope.row.isshow">{{langtrans().wm[languageIndex]}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="plan" :label="langtrans().ddqjdd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="node" :label="langtrans().ddqjjd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="get_time" :label="langtrans().hfsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="op" :label="langtrans().cczzz[languageIndex]" min-width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="topar(scope.$index)">{{langtrans().czkkbj[languageIndex]}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import langtrans from "./js/offer.vue.trans.js";
	import formVue from "./form.vue";
	import qs from "qs";
	import { Message } from "element-ui";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';
	import strutils from "@/util/strutils.js";

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
				typeId: this.$route.query.typeId,
				tableData: [],
				obj: [],
				victimList: [],
				caseid: [],
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				st_time: "",
				en_time: "",
				pickerOptions1: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				}
			};
		},
		methods: {
			setTxt(str,status){
				return constants.setTxt(str,status)
			},			
			langtrans() {
				return langtrans
			},
			filt() {
				this.getData(this.st_time, this.en_time + 86400000);
			},
			sttime() {
				this.st_time = this.st_time * 1;
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(langtrans().jjssjj[languageIndex]);
				}
				// this.getData(this.st_time, 0);
				// console.log(this.st_time);
			},
			entime() {
				this.en_time = this.en_time * 1;
				if(this.en_time + 86400000 < this.st_time && this.en_time != "") {
					Message.error(langtrans().jjssjj[languageIndex]);
				}
				// this.getData(0, this.en_time);
			},
			getData(st, et) {
				this.tableData = [];
				let that = this;
				let n = 0;
				let sex = "";
				let isshow = false;
				let stTime = st || this.st_time;
				let enTime = et || this.en_time;
				let tl = '';
				if(stTime && enTime) {
					tl = tl + `&startTs=${stTime}&endTs=${enTime}`;
				}
				fetch(constants.domain + "rescue/case/list_case", {
						method: "POST",
						body: `token=${this.token}&typeId=${this.typeId}&status=140&status=150&status=160&submit=1` + tl,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					})
					.then(function(res) {
						return res.json();
					})
					.then(function(data) {
						that.tableData=[]
						if(data.obj) {
							data.obj.map(v => {
								if(v == null)
									return;
								n = n + 1;
									if(that.languageIndex == 0){
										if(v.victimList[0].obj.gender == 1) {//汉语
											sex = "男";
										} else {
											sex = "女";
										}										
									}else{
										if(v.victimList[0].obj.gender == 1) {//汉语
											sex = "Male";
										} else {
											sex = "Female";
										}										
									}
								if(
									v.victimList[0].obj.insurancePolicyNo &&
									v.victimList[0].obj.insurancePolicyNo != ""
								) {
									isshow = true;
								} else {
									isshow = false;
								}
								var pt = constants.pt2txt(v.obj.caseState);
								if(v.solutionState == 3) {
									pt.phase = "指挥中心关闭报价";
									pt.node = "报价已关闭";
								}
								if(that.languageIndex == 1){									
									pt.phase = pt.phaseEn
									pt.node = pt.nodeEn
								}
								var  address=''
									if(v.generalLocation){
										if(!constants.setTxt(v.generalLocation.addr,'zh')){
											address=v.generalLocation.addr
										}else{
											address=that.languageIndex== 0 ? constants.setTxt(v.generalLocation.addr,'zh') : constants.setTxt(v.generalLocation.addr,'en')
										}
									}		
                  console.log(v)
								that.tableData.push({
									number: n, //序号
									casenumber: v.obj.caseNo, //案件编号
									address: address, //地址
									username: v.victimList[0].obj.victimName,  //姓名
									phone: v.obj.reporterContact, //联系方式
									papers: v.victimList[0].obj.idNo || "无", //身份证号
									sex: sex, //性别
									time: constants.time(v.obj.incidentTs), //出险时间
									isshow: isshow, //保单
									insuranceUrl: v.insuranceUrl,
									plan: pt.phase, //进度
									node: pt.node, //节点
									get_time: constants.time(v.rInstiFeedbackTs),
                  subRegulatorId:v.obj.subRegulatorId,
									op: "查看并操作",
									insuranceUrl: v.insuranceUrl, //用户保险详情链接
								});
								that.caseid.push(v.obj.id);
								that.obj.push(v.obj);
								that.victimList.push(v.victimList[0]);
							});
						}
					});
			},
			topar(i) {
				//this.$router.push("lookinf");
				this.$router.push({
					name: "lookinf",
					params: {
						token: this.token
					},
					query: {
						typeId: this.typeId,
						caseid: this.caseid[i]
					}
				});
			},
			toUrl(url) {
				//window.open(url);
			},

		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			window.localStorage.setItem(
				"case",
				JSON.stringify({
					case: "Offer"
				})
			);
			this.getData();
		},
		watch:{
			languageIndex(){
				this.getData()
			}
		}
	};
</script>

<style scoped>
	@import url("../../css/table.css");
</style>


// WEBPACK FOOTER //
// src/components/fac/Offer.vue